module.exports = __webpack_public_path__ + "img/wss2.1cd1f1b9.png";